import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import AppleLoginMine from '../utils/AppleLoginMine';
import { getAuthHeader } from '../utils/tokenManager';
import './LinkAccount.css';

const apiUrl = process.env.REACT_APP_DJANGO_API_URL;
const webUrl = process.env.REACT_APP_WEB_URL;

const LinkAccount = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { account_id } = location.state || {};

    useEffect(() => {
        if (!account_id) {
            console.log("No account_id")
            navigate('/'); // Redirect to home if account_id is not available
        }
    }, [account_id, navigate]);

    const handleGoogleLogin = async (credentialResponse) => {
        const token = credentialResponse.credential;

        try {
            const decoded = jwtDecode(token);
            const response = await fetch(`${apiUrl}/api/google_login/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': getAuthHeader(),
                },
                body: JSON.stringify({
                    token,
                    account_id: account_id,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                console.log("Login successful:", data);
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify({ ...decoded, account_id: data.account_id }));
                navigate(`/${account_id}/onboarding`);
            } else {
                console.error("Login failed:", response.statusText);
            }
        } catch (error) {
            console.error("Error during login:", error);
        }
    };

    return (
        <div className="link-account-container">
            <div className="link-account-content">
                <h1 className="link-account-title">Welcome to TapTipGo</h1>
                <p className="welcome-message">
                    Please create an account for your device to make tipping easy.
                </p>
                <div className="google-login-container">
                    <GoogleLogin
                        onSuccess={handleGoogleLogin}
                        onError={() => console.log('Login failed')}
                        ux_mode="popup"
                        shape="rectangular"
                        theme="filled_blue"
                        size="large"
                        text="continue_with"
                        locale="en"
                    />
                </div>
                <div className="login-divider">
                    <span>or</span>
                </div>
                <div className="apple-login-container">
                    <AppleLoginMine />
                </div>
            </div>
        </div>
    );
};

export default LinkAccount;
